/** Basenames of files in `public/flags/` (keep in sync when adding assets). */
export const BOOK_LANGUAGE_FLAG_FILENAMES = [
  'china.png',
  'germany.png',
  'japan.png',
  'korea.png',
  'mongolia.png',
  'sweden.png',
  'uk.png',
  'us.png',
] as const;

export type BookLanguageFlagFile = (typeof BOOK_LANGUAGE_FLAG_FILENAMES)[number];

export function bookLanguageFlagPublicUrl(filename: string): string {
  const base = process.env.PUBLIC_URL ?? '';
  return `${base}/flags/${filename}`;
}
